const transform = data => {
  if (typeof(data.company) !== 'string') data.company = data.company['@id']
  return data
}

export default transform